import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/svg/time-white.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  type: "button",
  class: "btn slider-button NKT-P2"
}
const _hoisted_3 = {
  key: 0,
  class: "spinner-border spinner-border-sm loading-indicator"
}
const _hoisted_4 = {
  key: 1,
  class: ""
}
const _hoisted_5 = { class: "d-flex flex-row align-items-center justify-content-between" }
const _hoisted_6 = { class: "flex-fill position-relative mx-3 toggle-click-child" }
const _hoisted_7 = {
  key: 0,
  class: "spinner-border spinner-border-sm loading-indicator"
}

import { ref, onUpdated, computed, watch, PropType } from 'vue'
import { useDateTimeStore } from '@/stores/DateTimeFilterStore'
import { DateTimeFilterTypes } from '@/utilities/enums'


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeRange',
  props: {
  state: String as PropType<DateTimeFilterTypes>,
  isLoading: Boolean
},
  setup(__props) {

const props = __props
const timeRange = ref(0)
const timeRangePrev = ref(0)

const buttonWidth = ref(0)

const dateTimeStore = useDateTimeStore()

const updateSliderTime = () => {
  const hoursValue = timeRange.value / 60
  const minutesValue = timeRange.value % 60

  const hours = Math.floor(hoursValue).toString().padStart(2, '0')

  const minutes = minutesValue.toString().padStart(2, '0')

  if (isFutureDate(hours, minutes)) {
    timeRange.value = timeRangePrev.value
    return
  }

  const time = `${hours}:${minutes}`
  dateTimeStore.setTime(time)
}

const isFutureDate = (hours: string, minutes: string) => {
  const dateNow = new Date()
  const dateStored = dateTimeStore.dateTime!

  const isSameDate =
    dateNow.getDate() === dateStored.getDate() &&
    dateNow.getMonth() === dateStored.getMonth() &&
    dateNow.getFullYear() === dateStored.getFullYear()

  if (isSameDate) {
    const storedHours = dateNow.getHours()
    const storedMinutes = dateNow.getMinutes()
    const inputHours = parseInt(hours, 10)
    const inputMinutes = parseInt(minutes, 10)

    if (storedHours < inputHours || (storedHours === inputHours && storedMinutes < inputMinutes)) {
      return true
    }

    return false
  }

  return false
}

const moveButton = () => {
  return `${(timeRange.value / 1439) * 100}%`
}

onUpdated(() => {
  const button = document.getElementById('slider-button')
  if (button) {
    buttonWidth.value = button.offsetWidth
  }
})

const reactiveTime = computed(() => dateTimeStore.time)

watch(
  () => [props.state, dateTimeStore.time],
  ([newVal]) => {
    if (newVal !== DateTimeFilterTypes.Live) {
      const [hours, minutes] = reactiveTime.value.split(':').map(Number)
      timeRange.value = hours * 60 + minutes
    }
  }
)

watch(
  () => timeRange.value,
  (_, oldVal) => {
    timeRangePrev.value = oldVal
  }
)

return (_ctx: any,_cache: any) => {
  return (__props.state === _unref(DateTimeFilterTypes).Live)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            src: _imports_0,
            class: "icon"
          }, null, -1)),
          _createTextVNode(" " + _toDisplayString(reactiveTime.value) + " ", 1),
          (__props.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("div", {
            class: "NKT-P2 slider-text",
            id: "min"
          }, [
            _createElementVNode("span", null, "00:00")
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range slider",
                min: "0",
                max: "1439",
                step: "10",
                id: "timeRange",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
                onInput: updateSliderTime
              }, null, 544), [
                [_vModelText, timeRange.value]
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              id: "slider-button",
              class: "btn slider-button NKT-P2 mt-1 position-absolute",
              style: _normalizeStyle({
            left: moveButton(),
            transform: 'translateX(-50%)'
          })
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                src: _imports_0,
                class: "icon"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(reactiveTime.value) + " ", 1),
              (__props.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[3] || (_cache[3] = [
                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                  ])))
                : _createCommentVNode("", true)
            ], 4)
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "NKT-P2 slider-text",
            id: "max"
          }, [
            _createElementVNode("span", null, "24:00")
          ], -1))
        ])
      ]))
}
}

})